import script from "./ChatBot.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChatBot.vue?vue&type=script&lang=ts&setup=true"

import "./ChatBot.vue?vue&type=style&index=0&id=2a2dd167&scoped=true&lang=css"

import exportComponent from "C:\\Piraye-akademi\\delphinpiraye.VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a2dd167"]])

export default __exports__